export default __webpack_public_path__ + "static/media/diligencia.b149edc2.png";